import React from 'react';
import jwt from 'jsonwebtoken';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

import API from '../../../services/api';

import { getMoney, getItemValue, formatMoney } from '../../helpers';
import CustomInputMoney from '../../custom/inputmoney';
import CustomPopover from '../../custom/popover';
import CustomAlert from '../../custom/alert';

import CustomTableToolbar from './toolbar';
import CustomTableHead from './header';
import useStyles from './styles';

//const userKeys = (key) => {
//  switch (key) {
//    case 'account':
//      return ['id'];
//    case 'classe':
//      return ['classe', 0, 'name'];
//    case 'name':
//      return ['name'];
//    case 'school':
//      return ['classe', 0, 'serie', 'school', 'name'];
//    case 'serie':
//      return ['classe', 0, 'serie', 'name'];
//    default:
//      return [];
//  }
//};

const keys = (key) => {
  switch (key) {
    case 'account':
      return ['id'];
    case 'classe':
      return ['user', 'classe', 0, 'name'];
    case 'name':
      return ['user', 'name'];
    case 'saldo':
      return ['saldo'];
    case 'school':
      return ['user', 'classe', 0, 'serie', 'school', 'name'];
    case 'serie':
      return ['user', 'classe', 0, 'serie', 'name'];
    default:
      return [];
  }
};

// const handleOnClickSaque = (row) => (event) => {
//   console.log({ event, row });
// };

const handleOnClickTransferencia = (row) => (event) => {
  console.log({ event, row });
};

const columns = [
  {
    id: 'account',
    keys: keys('account'),
    label: 'Conta',
    align: 'left', // center|inherit|justify|left|right
    padding: 'none', // ["checkbox","default","none"]
    money: false,
    disablePadding: false,
    sortable: false,
    icon: undefined,
    onClick: undefined,
  },
  {
    id: 'name',
    keys: keys('name'),
    label: 'Cliente',
    align: 'left',
    padding: 'none',
    money: false,
    disablePadding: false,
    sortable: false,
    icon: undefined,
    onClick: undefined,
  },
  {
    id: 'school',
    keys: keys('school'),
    label: 'Agência',
    align: 'left',
    padding: 'none',
    money: false,
    disablePadding: false,
    sortable: false,
    icon: null,
    onClick: undefined,
  },
  {
    id: 'serie',
    keys: keys('serie'),
    label: 'Série',
    align: 'left',
    padding: 'default',
    money: false,
    disablePadding: false,
    sortable: false,
    icon: null,
    onClick: undefined,
  },
  {
    id: 'saldo',
    keys: keys('saldo'),
    label: 'Saldo',
    align: 'left',
    padding: 'default',
    money: true,
    disablePadding: false,
    sortable: false,
    icon: null,
    onClick: undefined,
  },
  {
    id: 'classe',
    keys: keys('classe'),
    label: 'Turma',
    align: 'center',
    padding: 'default',
    money: false,
    disablePadding: false,
    sortable: false,
    icon: null,
    onClick: undefined,
  },
  // {
  //   id: 'sacar',
  //   keys: null,
  //   label: 'Sacar',
  //   align: 'center',
  //   padding: 'none',
  //   money: false,
  //   disablePadding: false,
  //   sortable: true,
  //   icon: <MoneyOffIcon />,
  //   onClick: handleOnClickSaque,
  // },
  {
    id: 'transferir',
    label: 'Transferir',
    align: 'center',
    padding: 'default',
    money: false,
    disablePadding: false,
    sortable: true,
    keys: null,
    icon: <SyncAltIcon />,
    onClick: handleOnClickTransferencia,
  },
];

// eslint-disable-next-line
// String.prototype.capitalizeFirst = function() {
//   return this.charAt(0).toUpperCase() + this.slice(1);
// }

// eslint-disable-next-line
// String.prototype.capitalize = function() {
//   return this.toLowerCase().replace(/(^\w|\s\w)/g, s => s.toUpperCase());
// }

export default function CustomTable(props) {
  const load = React.useRef(true);
  const [reload, setReload] = React.useState(false);
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('name');
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [rows, setRows] = React.useState([]);
  const [row, setRow] = React.useState(null);
  const [rowsSelected, setRowsSelected] = React.useState([]);
  const [openDeposito, setOpenDeposito] = React.useState(false);
  const [openSaque, setOpenSaque] = React.useState(false);
  const [alert, setAlert] = React.useState({ open: false, message: '' });

  const [popup, setPopup] = React.useState(false);

  // const [expanded, setExpanded] = React.useState(false);
  // const handleChange = (panel) => (event, isExpanded) => {
  //   setExpanded(isExpanded ? panel : false);
  // };

  const [anchorEl, setAnchorEl] = React.useState(null);

  function onReloadChanged() {
    if (reload) {
      const classe_ids = JSON.parse(API.encryptedSessionStorage.getItem('classe_ids', API.encryptedSessionStorage.getTokenData().uid));
      const profile_id = Number(API.encryptedSessionStorage.getItem('profile_id', API.encryptedSessionStorage.getTokenData().uid));
      const params = profile_id === 2 ? { profile_id: 3, classe_ids } : null;
      API.Accounts.index({ ...params })
        .then(onSuccess)
        .catch(onFailure);
    }

    return function reloadChanged() {
      setReload(false);
      setRowsSelected([]);
    };
  }

  function componentDidMount() {
    if (load.current) {
      setReload(true);
    }
    return function componentWillUnmount() {
      load.current = false;
    };
  }

  React.useEffect(componentDidMount, []);
  React.useEffect(onReloadChanged, [reload]);

  const handleRowClick = (item) => (event) => {
    event.stopPropagation();
    if (!popup) {
      // setAnchorEl(event.currentTarget);
      setRow(item);
      setPopup(true);
    } else {
      setAnchorEl(null);
      setPopup(false);
    }
  };

  const handlePopoverClick = (item) => (event) => {
    event.stopPropagation();
    setRow(item);
    // setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setRowsSelected(rows);
    } else {
      setRowsSelected([]);
    }
  };

  const handleClick = (event, row) => {
    if (event.target.checked) {
      setRowsSelected([...rowsSelected, row]);
    } else {
      setRowsSelected(rowsSelected.filter((r) => r.id !== row.id));
    }
    /*
    const selectedIndex = selected.indexOf(row.name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, row.name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    setSelected(newSelected);
    */
  };

  function onSuccess(response) {
    if (load.current && response.data) {
      setRows(response.data.data);
    }
  }

  const onSuccessDeposito = (valor) => {
    const s = rowsSelected.length > 1 ? 's' : '';
    setAlert({
      open: true,
      message: rowsSelected.length + ' depósito' + s + ' no valor de ' + formatMoney(valor) + ' enviado' + s + ' com sucesso para aprovação do administrador.',
    });
  };

  const onSuccessSaque = () => {
    setReload(true);
  };

  function onFailure(error) {
    console.log(error.toString());
  }

  const handleChangePage = (event, newPage) => {
    event.stopPropagation();
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  function getLabelDisplayedRows({ from, to, count }) {
    const lastPage = Math.ceil(count / rowsPerPage) || 1;
    return <>{from > 0 ? `Exibindo: ${from} a ${to} Total: ${rows.length} Página ${page + 1} de ${lastPage}` : 'Nenhum resultado encontrado'}</>;
  }

  const DepositoDialog = ({ children, ...props }) => {
    const { open, setOpen } = props;
    const [description, setDescription] = React.useState('Atividade');
    const [value, setValue] = React.useState(0);
    const [validate, setValidate] = React.useState({});

    function handleCancel(event) {
      event.preventDefault();
      setOpen(false);
    }

    function handleDescriptionChange(event) {
      event.preventDefault();
      setDescription(event.target.value);
    }

    function handleConfirm(event) {
      event.preventDefault();
      const decoded = jwt.decode(sessionStorage.getItem('token'));
      const ids = rowsSelected.map((row) => row.id);

      if (!description) {
        setValidate({
          ...validate,
          description: 'Por favor, insira uma descrição',
        });
        return;
      }

      if (!value) {
        setValidate({ ...validate, valor: 'Por favor, insira um valor' });
        return;
      }

      API.Depositos.lote({
        ids: ids,
        owners_id: decoded.uid,
        valor: value,
        description: description,
        state_id: 1,
      })
        .then(onSuccessDeposito(value))
        .catch(onFailure);
      setOpen(false);
    }

    function handleKeyDown(event) {
      // Esc = 27
      if (event.which === 27) {
        handleCancel(event);
      }
      // Enter = 13
      else if (event.which === 13) {
        event.preventDefault();
        handleConfirm(event);
      }
    }

    return (
      <Dialog open={open} fullWidth={true} maxWidth={'sm'} onClose={handleCancel} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{'Depósito'}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {'Dejesa realizar o depósito para ' + rowsSelected.length + ' cliente' + (rowsSelected.length > 1 ? 's' : '') + ' selecionado' + (rowsSelected.length > 1 ? 's' : '') + '?'}
          </DialogContentText>
          <TextField
            helperText={validate.description || ''}
            error={validate.description ? true : false}
            onFocus={() => setValidate({ ...validate, description: null })}
            autoFocus={true}
            margin="dense"
            id="description"
            label="Descrição do depósito"
            type="text"
            value={description}
            fullWidth={true}
            onChange={handleDescriptionChange}
            onKeyDown={handleKeyDown}
          />
          <CustomInputMoney
            autoFocus={true}
            label="Valor do depósito"
            setValue={setValue}
            helperText={validate.valor || ''}
            error={validate.valor ? true : false}
            onFocus={() => setValidate({ ...validate, valor: null })}
            onKeyDown={handleKeyDown}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            {'Cancelar'}
          </Button>
          <Button onClick={handleConfirm} color="primary">
            {'Confirmar'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const SaqueDialog = ({ children, ...props }) => {
    const { open, setOpen } = props;
    const [description, setDescription] = React.useState('Compra');
    const [value, setValue] = React.useState(0);
    const [validate, setValidate] = React.useState({});

    function handleCancel(event) {
      event.preventDefault();
      setOpen(false);
    }

    function handleDescriptionChange(event) {
      event.preventDefault();
      setDescription(event.target.value);
    }

    function handleConfirm(event) {
      event.preventDefault();
      const decoded = jwt.decode(sessionStorage.getItem('token'));
      const ids = rowsSelected.map((row) => row.id);

      if (!description) {
        setValidate({
          ...validate,
          description: 'Por favor, insira uma descrição',
        });
        return;
      }

      if (!value) {
        setValidate({ ...validate, valor: 'Por favor, insira um valor' });
        return;
      }

      if (rowsSelected.find((row) => row.saldo < value)) {
        setValidate({
          ...validate,
          valor: 'Um ou mais clientes não possui saldo suficiente para esta operação, Por favor informe outro valor ou revise a seleção dos clientes',
        });
        return;
      }
      API.Saques.lote({
        ids: ids,
        owners_id: decoded.uid,
        valor: value,
        description: description,
      })
        .then(onSuccessSaque(value))
        .catch(onFailure);
      setOpen(false);
    }

    function handleKeyDown(event) {
      // Esc = 27
      if (event.which === 27) {
        handleCancel(event);
      }
      // Enter = 13
      else if (event.which === 13) {
        event.preventDefault();
        handleConfirm(event);
      }
    }

    return (
      <Dialog open={open} fullWidth={true} maxWidth={'sm'} onClose={handleCancel} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{'Saque'}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {'Dejesa realizar o saque para ' + rowsSelected.length + ' cliente' + (rowsSelected.length > 1 ? 's' : '') + ' selecionado' + (rowsSelected.length > 1 ? 's' : '') + '?'}
          </DialogContentText>
          <TextField
            helperText={validate.description || ''}
            error={validate.description ? true : false}
            onFocus={() => setValidate({ ...validate, description: null })}
            autoFocus={true}
            margin="dense"
            id="description"
            label="Descrição do saque"
            type="text"
            value={description}
            fullWidth={true}
            onChange={handleDescriptionChange}
            onKeyDown={handleKeyDown}
          />
          <CustomInputMoney
            autoFocus={true}
            label="Valor do saque"
            setValue={setValue}
            helperText={validate.valor || ''}
            error={validate.valor ? true : false}
            onFocus={() => setValidate({ ...validate, valor: null })}
            onKeyDown={handleKeyDown}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            {'Cancelar'}
          </Button>
          <Button onClick={handleConfirm} color="primary">
            {'Confirmar'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  function descendingComparator(a, b, orderBy) {
    const A = getItemValue(a, keys(orderBy));
    const B = getItemValue(b, keys(orderBy));
    if (B < A) {
      return -1;
    }
    if (B > A) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const toolBarButtons = [
    {
      title: 'Depositar',
      icon: <AttachMoneyIcon />,
      onClick: () => setOpenDeposito(true),
    },
    {
      title: 'Sacar',
      icon: <MoneyOffIcon />,
      onClick: () => setOpenSaque(true),
    },
  ];

  return (
    <div className={classes.root}>
      <DepositoDialog open={openDeposito} setOpen={setOpenDeposito}></DepositoDialog>
      <SaqueDialog open={openSaque} setOpen={setOpenSaque}></SaqueDialog>
      <CustomPopover open={Boolean(anchorEl)} item={anchorEl} onClose={handlePopoverClose} data={row}></CustomPopover>

      <Paper className={classes.paper}>
        <CustomTableToolbar numSelected={rowsSelected.length} buttons={toolBarButtons} />
        <TableContainer>
          <Table className={classes.table} aria-labelledby="tableTitle" size={dense ? 'small' : 'medium'} aria-label="enhanced table">
            <CustomTableHead
              classes={classes}
              numSelected={rowsSelected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              columns={columns}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = rowsSelected.indexOf(row) !== -1;
                  const labelId = `table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={index}
                      selected={isItemSelected}
                      onClick={handleRowClick(row)}
                      onMouseOver={handlePopoverClick(row)}
                      onMouseLeave={handlePopoverClose}
                    >
                      {/*
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-label="Expand"
                            aria-controls="additional-actions1-content"
                            id="additional-actions1-header"
                          >
                            <FormControlLabel
                              aria-label="Acknowledge"
                              onClick={(event) => event.stopPropagation()}
                              onFocus={(event) => event.stopPropagation()}
                              control={<Checkbox />}
                              label={getItemValue(row, ['name'])}
                            />
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography color="textSecondary">
                              {getItemValue(row, ['classe', 0, 'serie', 'school', 'name'])}
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                        */}
                      <TableCell key={'checkbox-' + index} padding="checkbox">
                        <Checkbox onClick={(event) => handleClick(event, row)} checked={isItemSelected} inputProps={{ 'aria-labelledby': labelId }} />
                      </TableCell>

                      {/* <TableCell component="th" id={labelId} scope="row" padding="none">
                        {getItemValue(row, keys('name'))}
                      </TableCell> */}

                      {/* <TableCell align="left">{getItemValue(row, keys('school'))}</TableCell> */}

                      {/* <TableCell align="left">{getItemValue(row, keys('serie')) + ' ' + getItemValue(row, keys('classe'))}</TableCell> */}

                      {/* <TableCell align="center">
                        <IconButton size="small" onClick={(e) => console.log(e)}>
                          <AttachMoneyIcon />
                        </IconButton>
                      </TableCell> */}

                      {columns.map((column) => {
                        return (
                          <TableCell component="th" scope="row" padding={column.disablePadding ? 'none' : 'default'} key={column.id + '-' + index} align={column.align || 'justify'}>
                            {Array.isArray(column.keys) && column.keys.length > 0 && (column.money ? getMoney(row, column.keys) : getItemValue(row, column.keys))}
                            {column.icon && (
                              <IconButton size="small" onClick={column.onClick(row)}>
                                {column.icon}
                              </IconButton>
                            )}
                          </TableCell>
                        );
                      })}

                      {/* <TableCell align="center"><IconButton size="small" onClick={e => console.log(e)}><DeleteIcon /></IconButton></TableCell> */}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100, 200]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonText={'Página anterior'}
          labelRowsPerPage={'Linhas por página: '}
          nextIconButtonText={'Próxima página'}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelDisplayedRows={getLabelDisplayedRows}
          classes={{
            root: classes.tablePagination,
            caption: classes.tablePaginationCaption,
            selectIcon: classes.tablePaginationSelectIcon,
            select: classes.tablePaginationSelect,
            actions: classes.tablePaginationActions,
          }}
        />
      </Paper>
      <FormControlLabel control={<Switch checked={dense} onChange={handleChangeDense} />} label="Dense padding" />
      <CustomAlert open={alert.open} onClose={() => setAlert({ ...alert, open: false })}>
        {alert.message}
      </CustomAlert>
    </div>
  );
}
